export const DEPARTMENTS_LOADING = 'DEPARTMENTS_LOADING';
export const DEPARTMENTS_LOADED = 'DEPARTMENTS_LOADED';
export const DEPARTMENTS_ERROR = 'DEPARTMENTS_ERROR';
export const NEW_DEPARTMENT_LOADING = 'NEW_DEPARTMENT_LOADING';
export const NEW_DEPARTMENT_SUCCESS = 'NEW_DEPARTMENT_SUCCESS';
export const NEW_DEPARTMENT_FAIL = 'NEW_DEPARTMENT_FAIL';
export const RESET_DEPARTMENT_STATE = 'RESET_DEPARTMENT_STATE';

export const LABS_LOADING = 'LABS_LOADING';
export const LABS_LOADED = 'LABS_LOADED';
export const LABS_ERROR = 'LABS_ERROR';
export const NEW_LAB_LOADING = 'NEW_LAB_LOADING';
export const NEW_LAB_SUCCESS = 'NEW_LAB_SUCCESS';
export const NEW_LAB_FAIL = 'NEW_LAB_FAIL';
export const RESET_LAB_STATE = 'RESET_LAB_STATE';
export const LAB_ASSIGN_LECTURER_RESET = 'LAB_ASSIGN_LECTURER_RESET';
export const LAB_ASSIGN_LECTURER_LOADING = 'LAB_ASSIGN_LECTURER_LOADING';
export const LAB_ASSIGN_LECTURER_SUCCESS = 'LAB_ASSIGN_LECTURER_SUCCESS';
export const LAB_ASSIGN_LECTURER_ERROR = 'LAB_ASSIGN_LECTURER_ERROR';

export const DEPT_LABS_LOADING = 'DEPT_LABS_LOADING';
export const DEPT_LABS_LOADED = 'DEPT_LABS_LOADED';
export const DEPT_LABS_ERROR = 'DEPT_LABS_ERROR';

export const ADMINS_LOADING = 'ADMINS_LOADING';
export const ADMINS_LOADED = 'ADMINS_LOADED';
export const ADMINS_ERROR = 'ADMINS_ERROR';
export const NEW_ADMIN_LOADING = 'NEW_ADMIN_LOADING';
export const NEW_ADMIN_SUCCESS = 'NEW_ADMIN_SUCCESS';
export const NEW_ADMIN_FAIL = 'NEW_ADMIN_FAIL';
export const RESET_ADMIN_STATE = 'RESET_ADMIN_STATE';

export const STUDENTS_LOADING = 'STUDENTS_LOADING';
export const STUDENTS_LOADED = 'STUDENTS_LOADED';
export const STUDENTS_ERROR = 'STUDENTS_ERROR';
export const NEW_STUDENT_LOADING = 'NEW_STUDENT_LOADING';
export const NEW_STUDENT_SUCCESS = 'NEW_STUDENT_SUCCESS';
export const NEW_STUDENT_FAIL = 'NEW_STUDENT_FAIL';
export const RESET_STUDENT_STATE = 'RESET_STUDENT_STATE';
export const STUDENT_BLOCK_UNBLOCK_LOADING = 'STUDENT_BLOCK_UNBLOCK_LOADING';
export const STUDENT_BLOCK_UNBLOCK_SUCCESS = 'STUDENT_BLOCK_UNBLOCK_SUCCESS';
export const STUDENT_BLOCK_UNBLOCK_ERROR = 'STUDENT_BLOCK_UNBLOCK_ERROR';

export const LECTURERS_LOADING = 'LECTURERS_LOADING';
export const LECTURERS_LOADED = 'LECTURERS_LOADED';
export const LECTURERS_ERROR = 'LECTURERS_ERROR';
export const NEW_LECTURER_LOADING = 'NEW_LECTURER_LOADING';
export const NEW_LECTURER_SUCCESS = 'NEW_LECTURER_SUCCESS';
export const NEW_LECTURER_FAIL = 'NEW_LECTURER_FAIL';
export const RESET_LECTURER_STATE = 'RESET_LECTURER_STATE';
export const LECTURER_BLOCK_UNBLOCK_LOADING = 'LECTURER_BLOCK_UNBLOCK_LOADING';
export const LECTURER_BLOCK_UNBLOCK_SUCCESS = 'LECTURER_BLOCK_UNBLOCK_SUCCESS';
export const LECTURER_BLOCK_UNBLOCK_ERROR = 'LECTURER_BLOCK_UNBLOCK_ERROR';

export const LAB_MANAGERS_LOADING = 'LAB_MANAGERS_LOADING';
export const LAB_MANAGERS_LOADED = 'LAB_MANAGERS_LOADED';
export const LAB_MANAGERS_ERROR = 'LAB_MANAGERS_ERROR';
export const NEW_LAB_MANAGER_LOADING = 'NEW_LAB_MANAGER_LOADING';
export const NEW_LAB_MANAGER_SUCCESS = 'NEW_LAB_MANAGER_SUCCESS';
export const NEW_LAB_MANAGER_FAIL = 'NEW_LAB_MANAGER_FAIL';
export const RESET_LAB_MANAGER_STATE = 'RESET_LAB_MANAGER_STATE';
export const LAB_MANAGER_BLOCK_UNBLOCK_LOADING =
  'LAB_MANAGER_BLOCK_UNBLOCK_LOADING';
export const LAB_MANAGER_BLOCK_UNBLOCK_SUCCESS =
  'LAB_MANAGER_BLOCK_UNBLOCK_SUCCESS';
export const LAB_MANAGER_BLOCK_UNBLOCK_ERROR =
  'LAB_MANAGER_BLOCK_UNBLOCK_ERROR';

export const LAB_ASSISTANTS_LOADING = 'LAB_ASSISTANTS_LOADING';
export const LAB_ASSISTANTS_LOADED = 'LAB_ASSISTANTS_LOADED';
export const LAB_ASSISTANTS_ERROR = 'LAB_ASSISTANTS_ERROR';
export const NEW_LAB_ASSISTANT_LOADING = 'NEW_LAB_ASSISTANT_LOADING';
export const NEW_LAB_ASSISTANT_SUCCESS = 'NEW_LAB_ASSISTANT_SUCCESS';
export const NEW_LAB_ASSISTANT_FAIL = 'NEW_LAB_ASSISTANT_FAIL';
export const RESET_LAB_ASSISTANT_STATE = 'RESET_LAB_ASSISTANT_STATE';
export const LAB_ASSISTANT_BLOCK_UNBLOCK_LOADING =
  'LAB_ASSISTANT_BLOCK_UNBLOCK_LOADING';
export const LAB_ASSISTANT_BLOCK_UNBLOCK_SUCCESS =
  'LAB_ASSISTANT_BLOCK_UNBLOCK_SUCCESS';
export const LAB_ASSISTANT_BLOCK_UNBLOCK_ERROR =
  'LAB_ASSISTANT_BLOCK_UNBLOCK_ERROR';

export const ADMIN_SYSTEM_REPORT_LOADING = 'ADMIN_SYSTEM_REPORT_LOADING';
export const ADMIN_SYSTEM_REPORT_LOADED = 'ADMIN_SYSTEM_REPORT_LOADED';
export const ADMIN_SYSTEM_REPORT_ERROR = 'ADMIN_SYSTEM_REPORT_ERROR';
export const ADMIN_SYSTEM_REPORT_RESET = 'ADMIN_SYSTEM_REPORT_RESET';

export const ADMIN_LAB_REPORT_LOADING = 'ADMIN_LAB_REPORT_LOADING';
export const ADMIN_LAB_REPORT_LOADED = 'ADMIN_LAB_REPORT_LOADED';
export const ADMIN_LAB_REPORT_ERROR = 'ADMIN_LAB_REPORT_ERROR';
